import request from '../../util/request'
import { config } from '../../config/config'

export function getOrganizationMember(params) {
  return request({
    url: config.baseAPI + '/v1/institution/getUserListByOrgId',
    method: 'GET',
    params,
  })
}

export function getPersonnelSelectionList(params) {
  return request({
    url: config.baseAPI + '/v1/process/getPersonnelSelectionList',
    method: 'GET',
    params,
  })
}
